app.filter('html', ['$sce',
    function($sce) {
        return $sce.trustAsHtml;
    }
]);